document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.nexly-header').forEach((header) => {
    const burger = header.querySelector('.nexly-header__burger');
    const mobileMenu = header.querySelector('.nexly-header__mobile-menu');
    if (!burger || !mobileMenu) return;

    burger.addEventListener('click', () => {
      mobileMenu.classList.toggle('is-open');
      burger.classList.toggle('is-active');
    });
  });
});
